Wee.fn.make('product', {
	init: function() {
		var priv = this.$private;

		priv.initScreens();

		$.fetch.request({
			url: '/product/' + $('ref:productAdd').data('id') + '.json',
			json: true,
			success: function(response) {
				priv.$set('product', response);
				priv.initObservables();
				priv.initViews();

				$('ref:addToCart').csrf();

				priv.initEvents();
				priv.initCommerce();
			}
		});
	},
	unload: function() {
		this.destroyStickyProduct();

		Wee.flash.destroy();

		Wee.commerce.destroyQtySelector();
		Wee.commerce.destroyAddToCart();
	},
	destroyStickyProduct: function() {
		var priv = this.$private;

		if (priv.stickyProduct) {
			priv.stickyProduct.destroy({
				namespace: 'product'
			});
		}
	}
}, {
	/**
	 * Init screens
	 *
	 * @private
	 */
	initScreens: function() {
		var scope = this;

		$.screen.map([
			{
				max: 4,
				init: false,
				callback: function() {
					scope.$public.destroyStickyProduct();
				}
			},
			{
				min: 5,
				callback: function() {
					if ($('ref:product').height() > 1000) {
						if (! scope.stickyProduct) {
							scope.stickyProduct = new Wee.fn.sticky();
						}

						scope.stickyProduct.init('ref:productMedia', {
							namespace: 'product',
							container: 'ref:productMediaContainer',
							interval: 0,
							offset: 120,
							start: 120
						});
					}
				}
			}
		]);
	},

	/**
	 * Init observables
	 *
	 * @private
	 */
	initObservables: function() {
		this.$observe('product', function(data) {
			var app = $.app,
				selected = data.selected;

			app.productPrice.$set(selected);
			app.productQty.$set(selected);
		}, {
			recursive: true
		});
	},

	/**
	 * Init views
	 *
	 * @private
	 */
	initViews: function() {
		$.view.addHelper('multiple', function() {
			return this.val.length > 1;
		});

		$.app.make('productPrice', {
			target: 'ref:productPrice',
			view: 'product-price',
			model: this.$get('product').selected
		});

		$.app.make('productQty', {
			target: 'ref:productQty',
			view: 'product-qty',
			model: this.$get('product').selected
		});

		$('ref:productConfig').html($.view.render('product-config', this.$get('product')));
		$('ref:productStatus').html($.view.render('product-status', this.$get('product').selected));

		$.setRef();
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$('ref:productConfigSelect').on('change', function(e, el) {
			scope.$set('product.selected', scope.$get('product.variants.' + $(el)[0].selectedIndex));
		}, {
			namespace: 'productDetail'
		});
	},

	/**
	 * Init commerce methods
	 *
	 * @private
	 */
	initCommerce: function() {
		var context = 'product';

		Wee.commerce.initQtySelector();

		Wee.commerce.initAddToCart({
			success: function(response) {
				Wee.flash.init({
					model: {
						success: response.success,
						message: 'Item has been added to your cart.',
						context: context
					}
				});
			},
			error: function(response) {
				Wee.flash.init({
					model: {
						error: true,
						message: response.error ? response.error : 'Something went wrong, please try again.',
						context: context
					}
				});
			}
		});
	}
});